import React from "react";
import { Row, Col } from "reactstrap";
import styles from "./DesignGrid.module.scss";
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";

const DesignGrid = ({ data, layout }) => {
    return (
        <Row className={styles.designGrid}>
            {data?.map((item, index) => (
                <Col lg={layout === "Landscape" ? "6" : "4"} sm={layout === "Landscape" ? "12" : "6"} key={index} className={styles.imageDesignCol}>
                    <div>
                        <div className={styles.imgWrapper}>
                            <img src={item.image} alt="design" className={styles.designImage} />
                        </div>
                        <DynamicButton theme="gray">Download</DynamicButton>
                    </div>
                </Col>
            ))}
        </Row>
    );
};

export default DesignGrid;